import { render, staticRenderFns } from "./UserTicketChangeLogsDetailsView.vue?vue&type=template&id=f41f5f6c&scoped=true"
import script from "./UserTicketChangeLogsDetailsView.vue?vue&type=script&lang=js"
export * from "./UserTicketChangeLogsDetailsView.vue?vue&type=script&lang=js"
import style0 from "./UserTicketChangeLogsDetailsView.vue?vue&type=style&index=0&id=f41f5f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41f5f6c",
  null
  
)

export default component.exports